import objetivos from './assets/objetivos.png'
import conscientizar from './assets/conscientizar.png'
import oferecer from './assets/oferecer.png'
import transformar from './assets/transformar.png'
import proteger from './assets/proteger.png'

const Objetivos = () => {
    return ( 
        <div className="objetivos" id='objetivos'>
            <h2>Capacitando Jogadores a Manter o Equilíbrio e o Bem-Estar.</h2>
            <div className="objetivos-texts">
                <img src={objetivos} className='objetivo-background' alt="" />
                <div className="objetivos-cards">
                    <div className="card"><img src={conscientizar} alt="" />Conscientizar sobre os riscos do vício em apostas</div>
                    <div className="card"><img src={oferecer} alt="" />Oferecer suporte 24h acessível e eficaz ao apostador</div>
                    <div className="card"><img src={transformar} alt="" />Transformar a relação do jogador em divertimento</div>
                    <div className="card"><img src={proteger} alt="" />Proteger o futuro e a família do jogador</div>
                </div>
            </div>
        </div>
     );
}
 
export default Objetivos;